import ProductTempleteAmpturn from "../templates/product-templete-large";
import { LTResin } from '../data/products'

function ProductAmpturnResin() {
    return (
        <>
            <ProductTempleteAmpturn data = {LTResin}/>
        </>
    )
}

export default ProductAmpturnResin;